import handleValueOrFunction from '@iez/lib/handle-value-or-function'
import { onBeforeUnmount, onMounted, reactive } from '@vue/composition-api'

export const state = reactive({
  blockingProgression: null
})

export default () => {
  /**
   * {
   *   isActive: Boolean
   * }
   */
  const set = blockingProgression => {
    onMounted(
      () => {
        handleValueOrFunction({
          valueOrFunction: blockingProgression,
          callback: blockingProgression => {
            if (blockingProgression) {
              state.blockingProgression = blockingProgression
            } else {
              state.blockingProgression = null
            }
          }
        })
      }
    )

    onBeforeUnmount(
      () => {
        state.blockingProgression = null
      }
    )
  }

  return {
    set
  }
}
